// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__k1M5E","location":"Header_location__1Ss3r"};